import React, { useState, useEffect } from 'react';
import { Spin, Alert } from 'antd';
import { usePW9339Query } from './hooks/usePW9339Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/pw9339Api';
import './PW9339Form.css';

const PW9339Form: React.FC = () => {
  const { loading, result, queried, noData, defaultYear, defaultMonth, runQuery } = usePW9339Query();

  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');
  const [year, setYear] = useState(defaultYear);
  const [month, setMonth] = useState(defaultMonth);
  const [deptLevel, setDeptLevel] = useState(1);
  const [company, setCompany] = useState(1);

  // Update local state when defaults are loaded from backend
  useEffect(() => {
    setYear(defaultYear);
    setMonth(defaultMonth);
  }, [defaultYear, defaultMonth]);

  const handleQuery = () => {
    const req: QueryRequest = {
      year,
      month: month.trim(),
      deptFrom: deptFrom.trim(),
      deptTo: deptTo.trim() || 'zzzz',
      deptLevel,
      company,
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="pw9339-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          薪資明細表 (pw9339f1)
        </h2>

        <QueryParams
          deptFrom={deptFrom}
          deptTo={deptTo}
          year={year}
          month={month}
          deptLevel={deptLevel}
          company={company}
          loading={loading}
          onDeptFromChange={setDeptFrom}
          onDeptToChange={setDeptTo}
          onYearChange={setYear}
          onMonthChange={setMonth}
          onDeptLevelChange={setDeptLevel}
          onCompanyChange={setCompany}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的薪資資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default PW9339Form;
